import React from 'react';
import { useSelector } from 'react-redux'
import TargetHandle from '../TargetHandle';
import SourceHandle from '../SourceHandle';
import Iconify from '../../common/iconify/Iconify';
import { ICONIFY } from '../../../Constants/iconify';
import { Tooltip } from '@mui/material';
import { EXCLUDE_FOR_SIDEBAR_IPTS } from '../constant';

const fullSx = { width: '100%', height: '100%' }
const filterKeySx = { width: 16, height: '80%' }

function CommonNode({ data, icon, disableStyle, disableTargetHandle, disableSourceHandle }) {

    const lang = useSelector(state => state.lang.ui.lang);

    const keysToExclude = EXCLUDE_FOR_SIDEBAR_IPTS?.[data?.type] || []

    return (
        <div className={disableStyle ? '' : `callflow-node start-node ${data?.status == 'D' && 'disabled-node'}`}>
            {!disableTargetHandle && <TargetHandle id={data?.id} />}
            <Tooltip title={
                <div>{data?.question && Object.entries(data?.question).map(([key, value]) => (<div key={key}>{key}: {value}</div>))}</div>
            }>
                <div className="node-header">{data?.question?.[lang]}</div>
            </Tooltip>
            <div className="node-content">
                <div className="icons-wrapper">
                    <div className="node-content-main-icon">
                        <Iconify icon={icon} sx={fullSx} />
                    </div>
                    <div className="extra-icons-wrapper">
                        <div className='extra-icons-wrapper-upper'>
                            {data?.filterKey && (
                                <Tooltip title={`filterKey: ${data?.filterKey}`} hidden={!data?.filterKey}>
                                    <div className="node-filter-key">
                                        <Iconify icon={ICONIFY.filter} sx={filterKeySx} />
                                        <span>{data?.filterKey}</span>
                                    </div>
                                </Tooltip>
                            )}
                        </div>

                        <div className='extra-icons-wrapper-lower'>
                            <Tooltip title='mandatory' hidden={!data?.mandatory}>
                                <div className="node-content-icon">
                                    <Iconify icon={ICONIFY.asterisk} sx={fullSx} />
                                </div>
                            </Tooltip>
                            {
                                !keysToExclude.includes('inputMode') && (
                                    <Tooltip title='only number' hidden={!(data?.inputMode && data?.inputMode === 'number')}>
                                        <div className="node-content-icon">
                                            <Iconify icon={ICONIFY.numeric} sx={fullSx} />
                                        </div>
                                    </Tooltip>
                                )
                            }
                            {
                                !keysToExclude.includes('inputRegex') && (
                                    <Tooltip title='input regex' hidden={!data?.inputRegex}>
                                        <div className="node-content-icon">
                                            <Iconify icon={ICONIFY.regex} sx={fullSx} />
                                        </div>
                                    </Tooltip>
                                )
                            }
                            {
                                !keysToExclude.includes('minSize') && (
                                    <Tooltip title='min length limit' hidden={!data?.minSize}>
                                        <div className="node-content-icon">
                                            <Iconify icon={ICONIFY.minSize} sx={fullSx} />
                                        </div>
                                    </Tooltip>
                                )
                            }
                            {
                                !keysToExclude.includes('maxSize') && (
                                    <Tooltip title='max length limit' hidden={!data?.maxSize}>
                                        <div className="node-content-icon">
                                            <Iconify icon={ICONIFY.maxSize} sx={fullSx} />
                                        </div>
                                    </Tooltip>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
            {!disableSourceHandle && <SourceHandle id={data?.id} />}
        </div>
    );
};

export default React.memo(CommonNode)